import { useFlags } from '../services/launchDarkly';
import { useEntitlements } from './useEntitlements';

/**
 * Whether past-due indicators and fields should be shown on Account and Bill
 * Group screens. Enabled only when the `showPastDueFields` LaunchDarkly flag is
 * on AND the tenant has the billing entitlement. (Invoices are never gated by
 * this — they show past-due for everyone.)
 */
export const useShowPastDueFields = (): boolean => {
  const { showPastDueFields } = useFlags();
  const { billingEnabled } = useEntitlements();

  return Boolean(showPastDueFields) && billingEnabled;
};
